import React from "react";

function SvgPdf(props) {
  let blur = "";
  if(props.activeMove){
    blur="40";
  }
  return (
    <svg
    style={{verticalAlign:"middle"}}
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 14.916 19.69"
    >
      <g id="pdf_1_" data-name="pdf (1)" transform="translate(-58.428)">
        <path
          id="Path_16429"
          data-name="Path 16429"
          d="M68.913,0H58.9a.467.467,0,0,0-.468.468V19.223a.467.467,0,0,0,.468.468h13.98a.467.467,0,0,0,.468-.468V4.43a.468.468,0,0,0-.123-.32L69.233.123A.518.518,0,0,0,68.913,0Z"
          fill="#ebf0f3"
        />
        <path
          id="Path_16430"
          data-name="Path 16430"
          d="M320.248,4.812h3.741a.246.246,0,0,0-.1-.123L321.9,2.7,319.928.7a.431.431,0,0,0-.123-.1V4.344A.433.433,0,0,0,320.248,4.812Z"
          transform="translate(-250.695 -0.578)"
          fill="#d5d6db"
        />
        <path
          id="Path_16431"
          data-name="Path 16431"
          d="M111.644,175.572a1.091,1.091,0,0,1-.738-.32,1.257,1.257,0,0,1-.345-1.181.97.97,0,0,1,.418-.615,11.593,11.593,0,0,1,2.511-1.4,27.117,27.117,0,0,0,1.477-3.077,7.029,7.029,0,0,1-.788-2.289,2.179,2.179,0,0,1,.074-.985c.246-.788.788-.812,1.009-.788.049,0,.911.123,1.058,1.354a6.652,6.652,0,0,1-.566,2.683,8.545,8.545,0,0,0,1.92,2.264,11.361,11.361,0,0,1,2.781.32,1.047,1.047,0,0,1,.566.345.913.913,0,0,1,.172.96h0a1.022,1.022,0,0,1-.2.345.951.951,0,0,1-1.206.271,13.1,13.1,0,0,1-2.363-1.551,10.354,10.354,0,0,0-3.4.714c-.418.763-.935,1.6-1.526,2.535a1.037,1.037,0,0,1-.468.394h0C111.866,175.548,111.743,175.572,111.644,175.572Zm1.206-2.486A9.192,9.192,0,0,0,111.4,174c-.074.074-.148.148-.148.222a.583.583,0,0,0,.2.541.35.35,0,0,0,.3.074h0a.2.2,0,0,0,.123-.123C112.21,174.145,112.555,173.6,112.85,173.086Zm5.735-1.181a13.776,13.776,0,0,0,1.477.886.235.235,0,0,0,.3-.074.68.68,0,0,0,.1-.172c.049-.123.049-.172-.025-.246a.476.476,0,0,0-.222-.123A9.328,9.328,0,0,0,118.585,171.9Zm-3.2-2.191c-.246.566-.541,1.206-.935,1.944a11.234,11.234,0,0,1,2.166-.443A12.3,12.3,0,0,1,115.385,169.714Zm-.246-4.135c-.1,0-.172.1-.246.32a1.47,1.47,0,0,0-.049.665,6.151,6.151,0,0,0,.418,1.428,4.91,4.91,0,0,0,.32-1.674c-.074-.665-.418-.738-.443-.738Z"
          transform="translate(-49.967 -158.171)"
          fill="#e56353"
        />
      </g>
    </svg>
  );
}
export default React.memo(SvgPdf);
